import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Operator} from '../../../pages/user-management/operator/operator.model';
import {OperatorService} from '../../../services/api/operator.service';
import {UserInfoService} from '../../../services/user-info.service';

@Component({
    selector: 'vr-toolbar-user-button',
    templateUrl: './toolbar-user-button.component.html',
    styleUrls: ['./toolbar-user-button.component.scss']
})
export class ToolbarUserButtonComponent implements OnInit, AfterViewInit {

    isOpen: boolean;
    operator: Operator[];
    user = '';
    constructor(private userInfoService: UserInfoService, private operatorService: OperatorService) {
    }

    ngOnInit() {
        this.user = this.userInfoService.getUserName();

    }

    ngAfterViewInit() {
    }


   /* operators: string = this.userInfoService.getUserName();*/
   /* getAllOperator(pageNumber: any, noOfRecords: any) {
        if (this.userInfoService.getUserName()) {
            this.operatorService.getAllOperator(pageNumber, noOfRecords).subscribe(jsonResp => {
                    this.operator = jsonResp.data;
                },
                err => {
                    console.log(JSON.stringify(err));
                });
        }
        else {
            return false;
        }
    }*/
    toggleDropdown() {
        this.isOpen = !this.isOpen;
    }

    onClickOutside() {
        this.isOpen = false;
    }
}
